import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconRainbow: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="rainbow"><path d="M0.75 18C0.75 11.7868 5.7868 6.75 12 6.75C18.2132 6.75 23.25 11.7868 23.25 18M3.75 18C3.75 13.4437 7.44365 9.75 12 9.75C16.5563 9.75 20.25 13.4437 20.25 18M6.75 18C6.75 15.1005 9.10051 12.75 12 12.75C14.8995 12.75 17.25 15.1005 17.25 18M9.75 18C9.75 16.7574 10.7574 15.75 12 15.75C13.2426 15.75 14.25 16.7574 14.25 18" stroke="currentColor" strokeWidth="1.5"/></CentralIconBase>;
};

export default IconRainbow;
